export default __webpack_public_path__ + "static/media/Home2.8595e8e1.svg";